import Box from '@mui/material/Box';

import { KmxContainer } from '../../../components/KmxContainer';
import { SocialProof } from './SocialProof';
import LazyLoad from 'react-lazyload';
import useAppState from '../../../common/state/appState';

interface ISocialProofContainerProps {
    fullStoryPageId: string;
    nextFocus: string;
}

const SocialProofContainer = ({ fullStoryPageId, nextFocus }: ISocialProofContainerProps) => {
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);

    return (
        <LazyLoad offset={100}>
            <Box
                component="section"
                id="social-proof-carousel"
                sx={{
                    pt: serveUFTContentEnabled ? { xs: 8, sm: 12 } : { xs: 8, md: 12 },
                    overflow: 'hidden',
                }}
            >
                <KmxContainer maxWidth="xl">
                    <SocialProof fullStoryPageId={fullStoryPageId} nextFocus={nextFocus} />
                </KmxContainer>
            </Box>
        </LazyLoad>
    );
};

export default SocialProofContainer;
